export enum enumContractingParty {
  'none'= 1,
  'Merchant and Payer',
  'CSP and Payer'
}
export namespace enumContractingParty {
  export function values() {
    return Object.keys(enumContractingParty).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
